import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";

const id = "modal-add-contract";
const form = "add-contract";

const AddContract = ({ workflow }) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  return (
    <form
      action="/actions/getting-started/add-contract"
      method="POST"
      data-noreset
      id={form}
    >
      <input type="hidden" name="option" value="contract" />
      <input type="hidden" name="workflow" value={workflow._id} />

      <Modal
        name={id}
        key={id}
        title={t("addContract.title")}
        className="getting-started-video"
      >
        <div className="body">
          <div className="form-row-item">
            <label className="sub-label" htmlFor="contract">
              {t("addContract.label")}
            </label>
            <textarea
              type="text"
              name="contract"
              placeholder={t("addContract.placeholder")}
              defaultValue={workflow.options.contract?.contract}
              form={form}
              className="resize-y"
              rows={25}
              cols={70}
            />
          </div>
        </div>

        <footer className="foot">
          <button data-button-type="primary" type="submit">
            {t("common:add")}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default AddContract;
